import styled from 'styled-components'

import GCashRightButton from '../../../../../assets/img/gcash/gcash-right.png'
import GCash from '../../../../../assets/img/gcash/gcash-logo.png'

export const GCashContainer = styled.div`
  margin: 0 1.1rem 1rem 1.1rem;
`
export const GCashStatusMessage = styled.div`
  ${props => (props.isButton ? 'cursor: pointer;' : '')}
  width: 100%;
  box-sizing: border-box;

  background-color: #ffffff;
  margin: 25px 0rem 0.5rem 0rem;
  color: #8a8a8a;
  border: 1px solid #dddddd;
  font-size: 0.9rem;
  padding: 1rem;
  border-radius: var(--border-radius-button);
  display: flex;
  img {
    position: initial;
  }
  .right-button {
    width: 0.45rem;
  }
  span {
    /*text-align: center;*/
    flex: 1;
  }
`

export const GCashIcon = styled.img.attrs({
  src: GCash,
  alt: 'gcash logo',
})`
  /*height: 1.75rem;
position: sticky;
left: 2rem;
top: 2rem;*/
  height: 3rem;
  margin-right: 1rem;
`

export const GCashMessage = styled.div``

export const GCashHeader = styled.div`
  font-size: 0.8rem;
  font-weight: var(--font-weight-bold);
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  color: #007cff;
`

export const GCashActionButton = styled.div`
  font-size: 0.6rem;
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  cursor: pointer;
`

export const GCashDescription = styled.div`
  font-size: 0.6rem;
`

export const RightButton = styled.img.attrs({
  src: GCashRightButton,
})`
  ${({ variant }) =>
    variant === 'missing-data' &&
    'filter: grayscale(1) invert(1) contrast(1500%);'}

  width: 0.45rem;
`
